<template>
    <div>
        <header class="header navbar-fixed-top">
            <nav class="navbar" role="navigation">
                <div class="container">
                    <div class="menu-container js_nav-item">
                        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".nav-collapse">
                            <!--<span class="sr-only">Toggle navigation</span>-->
                            <span class="toggle-icon"></span>

                        </button>

                        <div class="logo">
                            <a class="logo-wrap" href="#body">
                                <img class="logo-img logo-img-main" src="img/logo.png" alt="FlameOnePage Logo">
                                <img class="logo-img logo-img-active" src="img/logo-dark.png" alt="FlameOnePage Dark Logo">
                            </a>
                        </div>
                    </div>

                    <div class="collapse navbar-collapse nav-collapse">
                        <div class="menu-container">
                            <ul class="nav navbar-nav navbar-nav-right">
                                <li class="js_nav-item nav-item" v-for="(item, idx) in  maodianlist" :key="item.name"><a
                                        class="nav-item-child nav-item-hover" :class="idx == modianactive ? 'myactive' : ''"
                                        @click.prevent="gotomaodian(idx, item.detail)">{{ item.name }}</a></li>
                                <li class="js_nav-item nav-item hideblock"> <a class="nav-item-child nav-item-hover">
                                        <el-select v-model="langvalue" popper-class="myclass" style="width: 80px;"
                                            @change="changeLang">
                                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </header>

        <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner" role="listbox">
                <div class="item active">
                    <img class="img-responsive" src="img/1920x1080/01.jpg" alt="Slider Image">
                    <div class="container">
                        <div class="carousel-centered">
                            <div class="margin-b-40">
                                <h1 class="carousel-title">{{ $t('main.bannertitle') }}</h1>
                                <p class="color-white hiddencon">
                                    针对行业特点，基于机器学习、深度学习、机器视觉等技术，通过大数据分析，定制<span class="showcon">...</span></p>
                                <p class="color-white hiddencon ppy">符合客户个性化需求的大数据分析服务和解决方案，帮助客户实现智能化升级。
                                </p>
                            </div>
                            <a @click.prevent="gotomaodian(4, 'contact')"
                                class="btn-theme btn-theme-sm btn-white-brd text-uppercase">详情</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--产品-->
        <div id="products">
            <div style="background-color: #1A1C1F;">
                <div class="content-lg container aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                    <div class="row margin-b-120">
                        <div class="col-sm-6 ">
                            <h2 style="color:#fff">{{ protitle }}</h2>
                            <p style="color:#999">
                                {{ prolable }}
                            </p>
                        </div>
                    </div>
                    <div class="mycontent margin-b-120 nomargin-b">
                        <img src="img/cx.png" style="width: 100%;border-radius: 12px;">
                        <div class="abs-con">
                            <div class="item">
                                <div style="height: 40%;width: 100%;display: flex;box-sizing: border-box;">
                                    <div class="onep pitem">
                                        <template v-if="deskwidth">
                                            <el-popover placement="right" trigger="click" popper-class="mydark">
                                                <div class="ineritem mydesk">
                                                    <div class="title">
                                                        <h3 class="text-white">{{ prolist[0].name }} </h3>
                                                        <div class="separator_small"></div>
                                                    </div>
                                                    <div class="listcon">
                                                        <div class="listitem" v-for="ite in prolist[0].list" :key="ite">{{
                                                            ite
                                                        }}</div>
                                                    </div>
                                                </div>
                                                <div class="tipscon cpb" slot="reference">
                                                    <div class="tipsconinner">
                                                        <div class="dotcon">
                                                            <div class="dot"></div>
                                                        </div>
                                                        <div class="text-white">{{ prolist[0].name }}</div>
                                                    </div>

                                                </div>
                                            </el-popover>
                                        </template>
                                        <div class="tipscon cpb" v-else>
                                            <div class="tipsconinner">
                                                <div class="dotcon">
                                                    <div class="dot"></div>
                                                </div>
                                                <div class="text-white">{{ prolist[0].name }}</div>
                                            </div>
                                        </div>
                                        <div class="ineritem">
                                            <div class="title">
                                                <h3 class="text-white">{{ prolist[0].name }} </h3>
                                                <div class="separator_small"></div>
                                            </div>
                                            <div class="listcon">
                                                <div class="listitem" v-for="ite in prolist[0].list" :key="ite">{{ ite }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sixp pitem">
                                        <template v-if="deskwidth">
                                            <el-popover placement="bottom" trigger="click" popper-class="mydark">
                                                <div class="ineritem mydesk">
                                                    <div class="title">
                                                        <h3 class="text-white">{{ prolist[1].name }} </h3>
                                                        <div class="separator_small"></div>
                                                    </div>
                                                    <div class="listcon">
                                                        <div class="listitem" v-for="ite in prolist[1].list" :key="ite">{{
                                                            ite
                                                        }}</div>
                                                    </div>
                                                </div>
                                                <div class="tipscon" slot="reference">
                                                    <div class="tipsconinner">
                                                        <div class="dotcon">
                                                            <div class="dot"></div>
                                                        </div>
                                                        <div class="text-white">{{ prolist[1].name }}</div>
                                                    </div>
                                                </div>
                                            </el-popover>
                                        </template>
                                        <div class="tipscon" v-else>
                                            <div class="tipsconinner">
                                                <div class="dotcon">
                                                    <div class="dot"></div>
                                                </div>
                                                <div class="text-white">{{ prolist[1].name }}</div>
                                            </div>
                                        </div>
                                        <div class="ineritem">
                                            <div class="title">
                                                <h3 class="text-white">{{ prolist[1].name }} </h3>
                                                <div class="separator_small"></div>
                                            </div>
                                            <div class="listcon">
                                                <div class="listitem" v-for="ite in prolist[1].list" :key="ite">{{ ite }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="twop pitem">
                                    <template v-if="deskwidth">
                                        <el-popover placement="right" trigger="click" popper-class="mydark">
                                            <div class="ineritem mydesk">
                                                <div class="title">
                                                    <h3 class="text-white">{{ prolist[2].name }}</h3>
                                                    <div class="separator_small"></div>
                                                </div>
                                                <div class="listcon">
                                                    <div class="listitem" v-for="ite in prolist[2].list" :key="ite">{{ ite
                                                    }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tipscon" slot="reference">
                                                <div class="tipsconinner">
                                                    <div class="dotcon">
                                                        <div class="dot"></div>
                                                    </div>
                                                    <div class="text-white">{{ prolist[2].name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </template>
                                    <div class="tipscon" v-else>
                                        <div class="tipsconinner">
                                            <div class="dotcon">
                                                <div class="dot"></div>
                                            </div>
                                            <div class="text-white">{{ prolist[2].name }}</div>
                                        </div>
                                    </div>
                                    <div class="ineritem">
                                        <div class="title">
                                            <h3 class="text-white">{{ prolist[2].name }}</h3>
                                            <div class="separator_small"></div>
                                        </div>
                                        <div class="listcon">
                                            <div class="listitem" v-for="ite in prolist[2].list" :key="ite">{{ ite }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item itemplus">
                                <div style="width: 100%;height: 50%; display: flex;">
                                    <div class="pitem" :class="1 ? item.classname : ''" v-for="item in prolist.slice(3, 5)"
                                    :key="item.name">
                                    <template v-if="deskwidth">
                                        <el-popover placement="left" trigger="click" popper-class="mydark">
                                            <div class="ineritem mydesk">
                                                <div class="title">
                                                    <h3 class="text-white">{{ item.name }}</h3>
                                                    <div class="separator_small"></div>
                                                </div>
                                                <div class="listcon">
                                                    <div class="listitem" v-for="ite in item.list" :key="ite">{{ ite }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tipscon" slot="reference">
                                                <div class="tipsconinner">
                                                    <div class="dotcon">
                                                        <div class="dot"></div>
                                                    </div>
                                                    <div class="text-white">{{
                                                        item.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </template>
                                    <div class="tipscon" v-else>
                                        <div class="tipsconinner">
                                            <div class="dotcon">
                                                <div class="dot"></div>
                                            </div>
                                            <div class="text-white">{{ item.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ineritem rightp">
                                        <div class="title">
                                            <h3 class="text-white">{{ item.name }}</h3>
                                            <div class="separator_small"></div>
                                        </div>
                                        <div class="listcon">
                                            <div class="listitem" v-for="ite in item.list" :key="ite">{{ ite }}</div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div class="pitem" :class="1 ? item.classname : ''" v-for="item in prolist.slice(5, 6)"
                                    :key="item.name">
                                    <template v-if="deskwidth">
                                        <el-popover placement="left" trigger="click" popper-class="mydark">
                                            <div class="ineritem mydesk">
                                                <div class="title">
                                                    <h3 class="text-white">{{ item.name }}</h3>
                                                    <div class="separator_small"></div>
                                                </div>
                                                <div class="listcon">
                                                    <div class="listitem" v-for="ite in item.list" :key="ite">{{ ite }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tipscon" slot="reference">
                                                <div class="tipsconinner">
                                                    <div class="dotcon">
                                                        <div class="dot"></div>
                                                    </div>
                                                    <div class="text-white">{{
                                                        item.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </template>
                                    <div class="tipscon" v-else>
                                        <div class="tipsconinner">
                                            <div class="dotcon">
                                                <div class="dot"></div>
                                            </div>
                                            <div class="text-white">{{ item.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ineritem rightp">
                                        <div class="title">
                                            <h3 class="text-white">{{ item.name }}</h3>
                                            <div class="separator_small"></div>
                                        </div>
                                        <div class="listcon">
                                            <div class="listitem" v-for="ite in item.list" :key="ite">{{ ite }}</div>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="section-seperator aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                <div class="content-md container">
                    <div class="row margin-b-40 ">
                        <div class="col-sm-6">
                            <h2>{{ $t('main.title') }}</h2>
                        </div>
                    </div>
                    <div class="masonry-grid row">
                        <div class="masonry-grid-item col-xs-12 col-sm-6 col-md-4 md-margin-b-30">
                            <!-- Work -->
                            <div class="work work-popup-trigger">
                                <div class="work-overlay">
                                    <img class="full-width img-responsive" src="img/解决方案图片/01.png" alt="Portfolio Image">
                                    <div class="work-overlay-inner">
                                        <div class="inner-con">
                                            <div class="titleitem">层前EL+外观AI智能检测系统</div>
                                            <div class="lineitem"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- End Work -->
                        </div>
                        <div class="masonry-grid-item col-xs-12 col-sm-6 col-md-4 md-margin-b-30">
                            <!-- Work -->
                            <div class="work work-popup-trigger">
                                <div class="work-overlay">
                                    <img class="full-width img-responsive" src="img/解决方案图片/02.png" alt="Portfolio Image">
                                    <div class="work-overlay-inner">
                                        <div class="inner-con">
                                            <div class="titleitem">叠焊后虚焊AI智能检测系统</div>
                                            <div class="lineitem"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- End Work -->
                        </div>
                        <div class="masonry-grid-item col-xs-12 col-sm-6 col-md-4">
                            <!-- Work -->
                            <div class="work work-popup-trigger">
                                <div class="work-overlay">
                                    <img class="full-width img-responsive" src="img/解决方案图片/03.png" alt="Portfolio Image">
                                    <div class="work-overlay-inner">
                                        <div class="inner-con">
                                            <div class="titleitem">串EL+外观AI智能检测系统</div>
                                            <div class="lineitem"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- End Work -->
                        </div>
                        <div class="masonry-grid-sizer col-xs-6 col-sm-6 col-md-1"></div>
                        <div class="masonry-grid-item col-xs-12 col-sm-6 col-md-4 margin-b-30 ">
                            <!-- Work -->
                            <div class="work work-popup-trigger">
                                <div class="work-overlay">
                                    <img class="full-width img-responsive" src="img/解决方案图片/04.png" alt="Portfolio Image">
                                    <div class="work-overlay-inner">
                                        <div class="inner-con">
                                            <div class="titleitem">边框接线盒灌胶AI智能检测系统</div>
                                            <div class="lineitem"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- End Work -->
                        </div>
                        <div class="masonry-grid-item col-xs-12 col-sm-6 col-md-8 margin-b-30 ">
                            <!-- Work -->
                            <div class="work work-popup-trigger">
                                <div class="work-overlay">
                                    <img class="full-width img-responsive" src="img/解决方案图片/05.png" alt="Portfolio Image">
                                    <div class="work-overlay-inner">
                                        <div class="inner-con">
                                            <div class="titleitem">层压后AI智能检测系统</div>
                                            <div class="lineitem"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- End Work -->
                        </div>
                    </div>
                    <!-- End Masonry Grid -->
                </div>
            </div>

        </div>
        <!--合作商-->
        <div id="work">
            <!-- Clients -->
            <div class="content-lg container">
                <!-- Swiper Clients -->
                <div class="swiper-slider swiper-clients">
                    <!-- Swiper Wrapper -->
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商1.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商2.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商3.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商4.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商5.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商6.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商7.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商8.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商9.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商10.png" alt="Clients Logo">
                        </div>
                        <div class="swiper-slide">
                            <img class="swiper-clients-img" src="img/合作商/合作商11.png" alt="Clients Logo">
                        </div>
                    </div>
                    <!-- End Swiper Wrapper -->
                </div>
                <!-- End Swiper Clients -->
            </div>
            <!-- End Clients -->
        </div>
        <!--服务-->
        <div id="services" class="">
            <div class="bg-color-sky-light aos-init aos-animate" data-aos="fade-up" data-aos-delay="300"
                data-auto-height="true">
                <div class="content-lg container">
                    <div class="row margin-b-40">
                        <div class="col-sm-6">
                            <h2>{{ servicestitle }}</h2>
                            <p>{{ servicesdetail }}</p>
                        </div>
                    </div>
                    <div class="row row-space-1 margin-b-2">
                        <div class="col-sm-4 sm-margin-b-2">
                            <div class="service" data-height="height">
                                <div class="service-element">
                                    <!--<i class="service-icon icon-chemistry"></i>-->
                                    <svg-icon iconClass="1zujianshengcan_menu" class="jsicon"></svg-icon>
                                </div>
                                <div class="service-info">
                                    <h3>{{ serviceslist[0].name }}</h3>
                                    <p class="margin-b-5">{{ serviceslist[0].detail }}</p>
                                </div>
                                <a href="javascript:void(0);" class="content-wrapper-link"></a>
                            </div>
                        </div>
                        <div class="col-sm-4 sm-margin-b-2">
                            <div class="service bg-color-base" data-height="height">
                                <div class="service-element">
                                    <svg-icon iconClass="2pinzhitisheng_menu" class="jsicon"
                                        style="color: #fff;"></svg-icon>
                                </div>
                                <div class="service-info">
                                    <h3 class="color-white">{{ serviceslist[1].name }}</h3>
                                    <p class="color-white margin-b-5">{{ serviceslist[1].detail }}</p>
                                </div>
                                <a href="javascript:void(0);" class="content-wrapper-link"></a>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="service" data-height="height">
                                <div class="service-element">
                                    <svg-icon iconClass="3quexianshengchan_menu" class="jsicon"></svg-icon>
                                </div>
                                <div class="service-info">
                                    <h3>{{ serviceslist[2].name }}</h3>
                                    <p class="margin-b-5">{{ serviceslist[2].detail }}</p>
                                </div>
                                <a href="javascript:void(0);" class="content-wrapper-link"></a>
                            </div>
                        </div>
                    </div>
                    <div class="row row-space-1">
                        <div class="col-sm-4 sm-margin-b-2">
                            <div class="service" data-height="height">
                                <div class="service-element">
                                    <svg-icon iconClass="4ziyuanpeizhi_menu" class="jsicon"></svg-icon>
                                </div>
                                <div class="service-info">
                                    <h3>{{ serviceslist[3].name }}</h3>
                                    <p class="margin-b-5">{{ serviceslist[3].detail }}</p>
                                </div>
                                <a href="javascript:void(0);" class="content-wrapper-link"></a>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="service" data-height="height">
                                <div class="service-element">
                                    <svg-icon iconClass="5quexianchuandi_menu" class="jsicon"></svg-icon>
                                </div>
                                <div class="service-info">
                                    <h3>{{ serviceslist[4].name }}</h3>
                                    <p class="margin-b-5">
                                        {{ serviceslist[4].detail }}</p>
                                </div>
                                <a href="javascript:void(0);" class="content-wrapper-link"></a>
                            </div>
                        </div>
                        <div class="col-sm-4 sm-margin-b-2">
                            <div class="service" data-height="height">
                                <div class="service-element">
                                    <svg-icon iconClass="6kejixianneng_menu" class="jsicon"></svg-icon>
                                </div>
                                <div class="service-info">
                                    <h3>{{ serviceslist[5].name }}</h3>
                                    <p class="margin-b-5">{{ serviceslist[5].detail }}</p>
                                </div>
                                <a href="javascript:void(0);" class="content-wrapper-link"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_maps text-center fix">
            <div class="overlay"></div>
            <div class="maps_text">
                <h3 class="text-white" onclick="showmap()">上海市闵行区上海紫竹科学园区5号楼<!--<i class="fa fa-angle-down"></i>--></h3>
                <div id="map_canvas" class="mapheight"></div>
            </div>
        </div>
        <!--联系我们-->
        <section id="contact" class="contact bg-mega fix" style="background-color: #1A1C1F;">
            <div class="container">
                <div class="row">
                    <div class="main_contact roomy-100 text-white">
                        <div class="col-md-4">
                            <div class="rage_widget">
                                <div class="widget_head">
                                    <h3 class="text-white">关于我们</h3>
                                    <div class="separator_small"></div>
                                </div>
                                <p style="padding-bottom: 10px;" class="color999">
                                    {{ aboutus }}
                                </p>
                               <!-- <div class="widget_head">
                                    <img src="/img/gcf.png" style="width: 300px;">
                                    <div class="separator_small"></div>
                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-8 sm-m-top-30">
                            <form class="" action="subcribe.php">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <input id="first_name" name="first_name" type="text" placeholder="请输入您的名字"
                                                class="form-control" v-model="formdata.name" :required="true">
                                        </div>
                                    </div>

                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <input id="phone" name="phone" type="text" placeholder="请输入您的电话"
                                                class="form-control" v-model="formdata.phone" :required="true">
                                        </div>
                                    </div>

                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <textarea class="form-control" rows="6" placeholder="请输入您想要留言的信息"
                                                v-model="formdata.info"></textarea>
                                        </div>
                                        <div class="form-group text-center">
                                            <a class="btn btn-primary" @click="submitdata">提 交 留 言</a>
                                        </div>
                                    </div>

                                </div>

                            </form>
                        </div>
                    </div>
                </div><!--End off row -->
            </div><!--End off container -->
        </section>
        <footer class="footer">
            <!-- Copyright -->
            <div class="content container">
                <div class="row">
                    <div class="col-xs-6 ytpmobile">
                        <p class="margin-b-0">
                            <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202014800"
                                class="ahoverstyle">
                                <img src="/img/ga.png" class="mygaclass" />沪公网安备 31011202014800号
                            </a>
                            <a href="https://beian.miit.gov.cn/#/Integrated/index"
                                class="ahoverstyle">沪ICP备2023012437号-2</a>
                        </p>
                    </div>
                    <div class="col-xs-6 text-right ytpmobile">
                        <p class="margin-b-0">Copyright &copy; 2023 优层智能科技（上海）有限公司. All Rights Reserved.</p>
                    </div>
                </div>
                <!--// end row -->
            </div>
            <!-- End Copyright -->
        </footer>
        <!-- Back To Top -->
        <a href="javascript:void(0);" class="js-back-to-top back-to-top">Top</a>
    </div>
</template>

<script>
import axios from 'axios';
import { baseUrl } from '../utils/baseUrl'
export default {
    data() {
        return {
            langvalue: '中文',
            options: [{
                value: '中文',
                label: '中文'
            }, {
                value: 'EN',
                label: 'EN'
            }],
            modianactive: 0,
            maodianlist: this.$t('main.maodianlist'),
            servicestitle: '技术特点',
            servicesdetail: '我们自主研发的闭源图像算法基于人工智能技术，经自主开发并成功应用于工业场景，能够实现小样本、高精度的AI检出。',
            serviceslist: this.$t('main.serviceslist'),
            aboutus: '优层智能科技（上海）有限公司成立于2018年，位于上海紫竹科技园，是国内一家致力于人工智能算法和深度学习原创技术的创新型科技公司。公司汇聚国内国外、各行业精英团队，自主研发并建立了深度学习平台和超算中心，为传统工业提供整体智能解决方案。',
            formdata: {
                name: '',
                phone: '',
                info: ''
            },
            deskwidth: true,
            protitle: '光伏组件全流程AI质检',
            prolable: ' 通过全流程的检测信息高度集成化和数据可视化，实现生产过程的信息采集。利用大数据工具，通过对检测数据的分析和挖掘，自我学习迭代，关联设备、工艺，实现可预见性维护，创造另一轮附加价值。',
            prolist: [
                {
                    name: '叠焊',
                    list: ['叠焊后虚焊检',
                        '点烫检',
                        '贴胶带检',
                        '一铺玻璃上料检',
                        '一铺EVA检',
                        '二铺玻璃上料检',
                        '二铺外观检',
                        '合玻后检',
                        '引线压平检检'],
                    classname: 'onep'
                }, {
                    name: '层前',
                    list: ['引线压平后贴条码检',
                        '组件el检',
                        '组件外观检'],
                    classname: 'sixp'

                }, {
                    name: '串焊',
                    list: [
                        '串EL检',
                        '串外观检',
                        '摆串裁切引导'
                    ],
                    classname: 'twop'
                },
                {
                    name: '层压',
                    list: [
                        '双玻层压前封边检',
                        '层压机入料护框检',
                        '层后爆板检测',
                        '层压出料爆板检',
                        '撕胶带检',
                        '层压后el检',
                        '层压后外观检测'
                    ],
                    classname: 'threep',

                    pad: 30
                }, {
                    name: '装框灌胶',
                    list: ['装框后检',
                        '调引线检及贴条码检',
                        '接线盒安装后检',
                        '线盒焊接检',
                        '人工补焊检',
                        '尺寸灌胶检',
                        '固化前边框检',
                        '固化后边框检'],
                    classname: 'fourp',
                    pad: 80
                }, {
                    name: '终检',
                    list: [
                        '终检el检',
                        '铭牌条码校验',
                        '三码校验检终检FI',
                        '包护角检',
                        '分档后整托检',
                        '包装后检'
                    ],
                    classname: 'fivep',
                    pad: 0
                }

            ],
            mybaseurl: ''

        }
    },
    watch: {
        //方法1
        "langvalue"(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.serviceslist = this.$t('main.serviceslist')
                this.maodianlist = this.$t('main.maodianlist')
            }
        }
    },
    mounted() {
        if (this.$route.params.change === 888) {
            location.reload()
        }
        this.mybaseurl = baseUrl
        const rect = document.body.getBoundingClientRect()
        this.deskwidth = (rect.width - 1 < 992)
        // console.log(this.deskwidth)

    },
    methods: {
        changeLang() {
            if (this.langvalue === 'EN') {   // 判断当前语言
                this.$i18n.locale = 'en'   // 设置当前语言
            } else {
                this.$i18n.locale = 'zn'
            }
        },
        //导航激活
        gotomaodian(idx, val) {
            this.modianactive = idx
            //此项是为了锚点不改变地址栏
            document.getElementById(val).scrollIntoView();
        },
        submitdata() {
            if (this.formdata.info) {
                if (this.formdata.phone) {
                    let reg =
                        /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;
                    if (!reg.test(this.formdata.phone) && (this.formdata.phone)) {
                        if (this.langvalue === 'EN') {
                            this.$message.warning("The phone number format is incorrect.");
                        } else {
                            this.$message.warning("手机号格式不正确");
                        }

                    } else {
                        //  console.log(this.mybaseurl,'xxx')
                        axios.post(`${this.mybaseurl}/gt_info/`, {
                            name: this.formdata.name || null,
                            phone: this.formdata.phone || null,
                            info: this.formdata.info
                        }).then(() => {
                            //置空传参
                            this.formdata = {
                                name: '',
                                phone: '',
                                info: ''
                            }
                            if (this.langvalue === 'EN') {
                                this.$message.success('We have received your message. Our staff will contact you shortly.')
                            } else {
                                this.$message.success('我们已经收到您的信息,稍后工作人员将会联系您')
                            }

                        }).catch(() => {
                            if (this.langvalue === 'EN') {
                                this.$message.error('An unknown error has occurred.')
                            } else {
                                this.$message.error('发生未知错误')
                            }

                        })

                    }
                } else {
                    //  console.log(this.mybaseurl,'xxx')
                    axios.post(`${this.mybaseurl}/gt_info/`, {
                        name: this.formdata.name || null,
                        phone: this.formdata.phone || null,
                        info: this.formdata.info
                    }).then(() => {
                        //置空传参
                        this.formdata = {
                            name: '',
                            phone: '',
                            info: ''
                        }
                        if (this.langvalue === 'EN') {
                            this.$message.success('We have received your message. Our staff will contact you shortly.')
                        } else {
                            this.$message.success('我们已经收到您的信息,稍后工作人员将会联系您')
                        }

                    }).catch(() => {
                        if (this.langvalue === 'EN') {
                            this.$message.error('An unknown error has occurred.')
                        } else {
                            this.$message.error('发生未知错误')
                        }

                    })

                }
            } else {
                if (this.langvalue === 'EN') {
                    this.$message.warning('Please fill in all required fields.')
                } else {
                    this.$message.warning('请填写留言')
                }
            }
        }
    }

}
</script>

<style>
.hideblock {
    /*none掉中英文切换按钮 */
    display: none !important;

}

.nav-item-child .el-input__inner {
    color: inherit;
    background-color: transparent;
    border: none;
    font-size: 14px;
    position: relative;
}

.el-select-dropdown__item span {
    color: #666;
}

.myclass {
    color: #000;
}

.work-overlay {
    position: relative;
    overflow: hidden;
}

.work-overlay .work-overlay-inner {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 120px;
    background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 70%, rgba(0, 0, 0, 1) 100%);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    box-sizing: border-box;
    padding-bottom: 24px;
    transition: all 1s;

}

.work-overlay:hover .work-overlay-inner {
    transition: all 1s;
    bottom: -120px;

}

.work-overlay .work-overlay-inner .inner-con {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
}

.work-overlay .work-overlay-inner .inner-con .titleitem {
    color: #fff;
    font-size: 14px;
    line-height: 14px;
    font-weight: bold;
}

.work-overlay .work-overlay-inner .inner-con .lineitem {
    width: 20px;
    height: 4px;
    border-radius: 4px;
    background-color: #e71e21;
}

.showcon {
    display: none;
}

.hiddencon {
    margin-bottom: 2px;
}

.margin-b-120 {
    margin-bottom: 120px;
}

.full-width {
    border-radius: 4px;
}

.myactive {
    color: #e71e21 !important;
}

.btn-white-brd {
    color: #fff !important;
}

.form-control {
    border-radius: 4px;

}

.jsicon {
    font-size: 30px;
    margin-bottom: 30px;
    color: #999caa;
}

.mydark {
    background-color: black !important;
    max-width: 250px;
    border: none;
}

.mysvgsty {
    font-size: 200px;
}

.bg-mega {
    background-color: #6a6b6c;
    color: #fff;
}

.main_contact {
    overflow: hidden;
}

.main_contact a.btn {
    width: 100%;
}

.widget_socail ul li a i {
    background-color: #434343;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    -webkit-transition: all 0.4s;
    -moz-transition: all 0.4s;
    -o-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
}

.widget_socail ul li a:hover i {
    background-color: #e71e21;
}

.roomy-100 {
    padding-top: 100px;
    padding-bottom: 100px;
}

.contact p {
    color: #fff;
}

.separator_small {
    width: 30px;
    height: 2px;
    margin: 20px 0px;
    background: #e71e21;
}

.text-white {
    color: #fff;
}

.contact .btn-primary {
    color: #fff;
    background-color: #e71e21;
    border: 1px solid;
    border-color: #e71e21;
    padding: 1rem 2rem;
}

.contact .btn-primary:hover {
    background-color: #eee;
    border-color: #eee;
    color: #e71e21;
}

/*maps*/
.main_maps {
    padding-top: 120px;
    background-image: url(/img/ditu.png);
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;
}

.main_maps::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #4343438e;
    z-index: 1;
}

.main_maps .map_canvas_icon {
    position: absolute;
    left: 45%;
    top: 35%;
    cursor: pointer;
    /*z-index: 2;*/
}

.main_maps i {
    font-size: 21rem;
    color: #e71e21;

}

.main_maps h2 {
    color: #e71e21;
}

.mapheight {
    height: 100px;
    width: 100%;
}

.maps_text {
    position: relative;
    z-index: 2;
}

.maps_text h3 i {
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 50%;
    background-color: #e71e21;
    color: #fff;
    font-size: 1rem;
    display: inline-block;
    top: -5px;
    position: relative;
    margin-left: 10px;
}

.mycontent {
    position: relative;
}

.abs-con {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-wrap: wrap;
    border-radius: 12px;
    box-sizing: border-box;
    
}

.abs-con .item {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    box-sizing: border-box;
}

.itemplus {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}



.onep {
    position: relative;
    width: 30%;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 4%;

}

.twop {
    position: relative;
    width: 76%;
    height: 60%;
    box-sizing: border-box;
    padding-left: 24%;
    padding-top: 3%;
}

.threep {
    position: relative;
    width: 60%;
    height: 100%;
    box-sizing: border-box;
}

.fourp {
    position: relative;
    width: 40%;
    height: 100%;
    box-sizing: border-box;
    padding-left: 16%;
    padding-top: 18%;
}

.fivep {
    position: relative;
    width: 100%;
    height: 50%;
    box-sizing: border-box;
    padding-left: 36%;
    padding-top: 6%;
}

.sixp {
    position: relative;
    width: 70%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 4%;
    padding-left: 12%;
}

.pitem {
    transition: all 1s;
    /*background-color: #00000071;*/
    border-radius: 8px;

}

.pitem:hover {
    transition: all 1s;
    background-color: transparent;
}


.ineritem {
    /*transition: all 1s;*/
    opacity: 0;
    visibility: hidden;
    position: absolute;
    padding: 30px;
    width: auto;
    top: 10px;
    left: 0;
    background-color: black;
    color: #fff;
    border-radius: 8px;
    z-index: 2;
    min-width:160px ;
}

.onep:hover .ineritem {
    visibility: visible;
    opacity: 1;
    transition: all 1s;
    left: 30%;
    z-index: 100;
}

.sixp:hover .ineritem {
    visibility: visible;
    opacity: 1;
    transition: all 1s;
    left: 10%;
    z-index: 100;
}

.twop:hover .ineritem {
    visibility: visible;
    opacity: 1;
    transition: all 1s;
    left: 30%;
    z-index: 100;
}

.threep:hover .ineritem {
    visibility: visible;
    opacity: 1;
    transition: all 1s;
    left: 30%;
    z-index: 100;
}

.fourp:hover .ineritem {
    visibility: visible;
    opacity: 1;
    transition: all 1s;
    left: 30%;
    z-index: 100;
}

.fivep:hover .ineritem {
    visibility: visible;
    opacity: 1;
    transition: all 1s;
    left: 30%;
    z-index: 100;
}

.tipscon {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
}

.twop .tipscon {
    align-items: flex-start;
    justify-content: flex-start;

}

.onep .tipscon {
    align-items: flex-end;
    justify-content: flex-end;

}

.sixp .tipscon {
    align-items: flex-start;
    justify-content: center;

}

.fourp .tipscon {
    align-items: flex-start;
    justify-content: flex-start;

}

.fivep .tipscon {
    align-items: flex-start;
    justify-content: flex-start;

}

.dotcon {
    width: 40px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;

}

.dot {
    width: 12px;
    height: 12px;
    background-color: #e71e21;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 1) inset;
    -webkit-animation-name: 'ripple';
    /*动画属性名，也就是我们前面keyframes定义的动画名*/
    -webkit-animation-duration: 2s;
    /*动画持续时间*/
    -webkit-animation-timing-function: ease;
    /*动画频率，和transition-timing-function是一样的*/
    -webkit-animation-delay: 0s;
    /*动画延迟时间*/
    -webkit-animation-iteration-count: infinite;
    /*定义循环资料，infinite为无限次*/
    -webkit-animation-direction: alternate;
    /*定义动画方式*/
}

.tipsconinner {
    display: flex;
    background-color: #000000b7;
    border-radius: 4px;
    padding-right: 16px;
    box-sizing: border-box;
}

.tipsconinner .text-white {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 14px;
}

@keyframes ripple {
    0% {

        opacity: 0.4;
        width: 10px;
        height: 10px;
    }

    100% {

        opacity: 0.8;
        width: 16px;
        height: 16px;
    }
}

.cpb60 {
    padding-left: 60px;

}

.color999 {
    color: #999 !important;
}

.ahoverstyle {
    margin-right: 10px;
}

.ahoverstyle:hover {
    color: #007aff;
    text-decoration: underline;
}

.mygaclass {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    margin-top: -2px;
}

@media screen and (max-width:992px) {
    .work-overlay:hover .work-overlay-inner {
        transition: all 1s;
        bottom: 0px;

    }

    /* .hiddencon {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin-bottom: 2px;
    }*/
    .service:hover .service-element {
        opacity: 1 !important;
        -webkit-transform: translate3d(0, 0, 0) !important;
        -moz-transform: translate3d(0, 0, 0) !important;
        transform: translate3d(0, 0, 0) !important;
    }

    .service:hover .service-info {
        -webkit-transform: translate3d(0, 0, 0) !important;
        -moz-transform: translate3d(0, 0, 0) !important;
        transform: translate3d(0, 0, 0) !important;
    }

    .ppy.hiddencon {
        display: none;
    }

    .showcon {
        display: inline-block;
    }

    .margin-b-120 {
        margin-bottom: 40px;
    }

    .nomargin-b {
        margin-bottom: 0px;
    }

    .tipscon {
        font-size: 12px;
    }

    .ineritem {
        display: none;
    }

    .ineritem.mydesk {
        display: block;
        position: static;
        opacity: 1;
        visibility: visible;
        width: auto;
        padding: 10px;

    }

    .dotcon {
        width: 20px;
        height: 16px;
    }

    .dot {
        width: 8px;
        height: 8px;
    }

    .tipsconinner {
        display: flex;
        background-color: #000000b7;
        border-radius: 4px;
        padding-right: 10px;
        box-sizing: border-box;
    }

    .tipsconinner .text-white {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        line-height: 10px;
    }

    @keyframes ripple {
        0% {

            opacity: 0.4;
            width: 6px;
            height: 6px;
        }

        100% {

            opacity: 0.8;
            width: 10px;
            height: 10px;
        }
    }

    .cpb60 {
        padding-left: 30px;

    }

}
</style>